import React from 'react';
import { HelpCircle } from 'lucide-react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { faqs as fallbackFaqs } from '../data/mock';
import { useContent } from '../hooks/useContent';

export default function FAQ() {
  const faqs = useContent('faqs_home', fallbackFaqs) || fallbackFaqs;
  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto max-w-4xl px-4 md:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand/10 text-brand text-xs font-semibold mb-3">
            <HelpCircle className="w-4 h-4" /> Frequently Asked Questions
          </div>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-primary mb-3">
            Everything Indian students and parents ask before choosing <span className="text-brand">Russia for MBBS</span>.
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-3">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`}
              className="bg-white rounded-xl border border-border px-5 hover:border-brand/50 data-[state=open]:border-brand data-[state=open]:shadow-md transition-colors">
              <AccordionTrigger className="text-left font-serif text-base md:text-lg font-bold text-primary hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground text-[15px] leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
